import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "../../integration/iframe"

export const Metrics: React.FC<RouteComponentProps> = () => (
  <>
    <IFrame path="metrics" />
  </>
)
